import KeyValueMap from './_key-value-map.js'
import Spinner from './_spinner.js'
import FlexPane from './_flex-pane.js'

export default {
  name: 'InfiniteList',
  values: {
    style: {
      configSet: KeyValueMap,
      configValues: {},
    },
    scrollThreshold: 0.8,
    height: undefined,
    spinner: {
      configSet: Spinner,
      configValues: {
        style: {
          container: {
            flexGrow: 0,
          },
        },
      },
    },
    spinnerContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
